import { inject, lifecycleHooks, IEventAggregator } from 'aurelia';
import { I18N } from '@aurelia/i18n';
import { LocaleChanged } from './messages/locale-changed';

const APP_NAME = 'Apply';

/**
 * Ger varje sida en egen titel, "Mina ansökningar – Apply", så att man vet var man är när fliken byter
 * innehåll (WCAG 2.4.2). Titeln är en översättningsnyckel i routens data.title och följer språket.
 */
@lifecycleHooks()
@inject(I18N, IEventAggregator)
export class PageTitle {
  constructor(i18n, ea) {
    this.i18n = i18n;
    this.key = null;
    ea.subscribe(LocaleChanged, () => this.apply());
  }

  loading(viewModel, params, next) {
    this.key = next.data?.title ?? null;
    this.apply();
  }

  apply() {
    document.title = this.key ? `${this.i18n.tr(this.key)} – ${APP_NAME}` : APP_NAME;
  }
}
